import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface AchievementPopupProps {
  achievementPopup: {id: string, name: string, description: string} | null;
  achievementIcon?: { path: string };
}

export const AchievementPopup: React.FC<AchievementPopupProps> = ({
  achievementPopup,
  achievementIcon
}) => {
  return (
    <AnimatePresence>
      {achievementPopup && (
        <motion.div
          className="achievement-popup"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          {achievementIcon && <img src={achievementIcon.path} alt="Achievement" className="achievement-icon" />}
          <div className="achievement-details">
            <h4>{achievementPopup.name}</h4>
            <p>{achievementPopup.description}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
